import { ProfileOutlined } from "@ant-design/icons";
import { CrudOp, partlistEntryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { PartlistView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(partlistEntryAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const partlistViewKey = "project_modular_partlist/:projectId/:subprojectId";
export const partlistViewModule: ViewModule = {
  viewKey: partlistViewKey,
  viewEl: <PartlistView/>,
  displayNameI18nKey: "partlist:viewName",
  menuIconEl: <ProfileOutlined/>,
  isAuthorized,
  translations,
};
